import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RenderTabs2 = ({ tabs }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (tabIndex, navigationPath) => {
    setActiveTab(tabIndex);
    if (navigationPath) {
      navigate(navigationPath);
    }
  };

  return (
    <>
      {tabs && tabs.length > 0 && (
        <div className="row">
          <div className="col-12">
            <div className="tab-section mb-0">
              <div className="tab-header">
                {tabs?.map((tab, index) => (
                  <button
                    key={index + 1}
                    className={activeTab === index ? 'active' : ''}
                    onClick={() => handleTabClick(index, tab.sPage)}
                  >
                    {tab.sMenuItemCaption}
                  </button>
                ))}
              </div>

              {tabs?.map((tab, index) => (
                !tab.isDynamic ?
                  <div key={index + 1} className={`tab-content`} style={{ display: activeTab === index ? 'block' : 'none' }}>
                    <div className="tab-body-section">
                      {tab.component} {/* Assuming tab.component holds the content of the tab */}
                    </div>
                  </div>
                  : null
              ))}
              {tabs[activeTab].isDynamic && activeTab !== -1 && tabs[activeTab].component && (
                <div className="tab-content">
                  <div className="tab-body-section">
                    {tabs[activeTab].component}
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      )}
    </>
  );
};

RenderTabs2.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      sMenuItemCaption: PropTypes.string.isRequired,
      sPage: PropTypes.string,
      isDynamic: PropTypes.bool,
      component: PropTypes.node,
    })
  ).isRequired,
};

export default RenderTabs2;
